"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This component serves mainly as a convenient control component for grouping multiple `<Radio>` components.
 *
 * If you require a more complex component tree, you will have to manage the radio selection state in your own
 * component.
 *
 * In terms of visuals, it only does two things:
 *  - Renders itself as the element defined by the `listElement` prop
 *  - Wraps each `Radio` into the element defined by the `itemElement` prop
 *
 * **NOTE**: Currently there is no way to pass props to these two wrapper components, but it could easily
 * be added in the future if the need arises.
 *
 */
// TODO Convert to FC
var RadioGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  var _super = _createSuper(RadioGroup);

  function RadioGroup() {
    var _this;

    _classCallCheck(this, RadioGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_warnUncontrolledToControlled", false);

    _defineProperty(_assertThisInitialized(_this), "_warnControlledToUncontrolled", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      current: _this.props.initialValue
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value, event) {
      _this.setState({
        current: value
      });

      if (_this.props.onChange) _this.props.onChange(value, event);
    });

    _defineProperty(_assertThisInitialized(_this), "decorateChild", function (el) {
      if (el && /*#__PURE__*/React.isValidElement(el)) {
        var additionalProps = {
          radioGroupChangeNotifier: _this.handleChange,
          checked: el.props.value === _this.state.current
        };
        var modifiedElement = /*#__PURE__*/React.cloneElement(el, additionalProps);
        return /*#__PURE__*/React.createElement(_this.props.itemElement, null, modifiedElement);
      }

      return el;
    });

    return _this;
  }

  _createClass(RadioGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var wasControlled = prevProps.value != null;
      var isControlled = this.props.value != null; // Warn about uncontrolled > controlled

      if (!wasControlled && isControlled) {
        this._warnUncontrolledToControlled = true;
        console.warn('Looks like the type of the value prop changed from being uncontrolled to controlled; this can lead to bugs.', 'See more: https://fb.me/react-controlled-components');
      } // Warn about controlled > uncontrolled


      if (wasControlled && !isControlled) {
        this._warnControlledToUncontrolled = false;
        console.warn('Looks like the type of the value prop changed from being controlled to uncontrolled; this can lead to bugs.', 'See more: https://fb.me/react-controlled-components');
      }

      if (this.props.value != null && this.props.value !== prevProps.value) this.setState({
        current: this.props.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      if (!children) return null;
      var modifiedChildren = React.Children.map(children, this.decorateChild);
      return /*#__PURE__*/React.createElement(this.props.listElement, null, modifiedChildren);
    }
  }]);

  return RadioGroup;
}(React.Component);

_defineProperty(RadioGroup, "defaultProps", {
  listElement: 'div',
  itemElement: 'div'
});

var _default = RadioGroup;
exports["default"] = _default;